import { render, staticRenderFns } from "./gpsxt.vue?vue&type=template&id=f64abd7e&scoped=true"
import script from "./gpsxt.vue?vue&type=script&lang=js"
export * from "./gpsxt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64abd7e",
  null
  
)

export default component.exports